import script from "./OpportunityRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunityRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__